import { TreatmentRecordRequestStatus } from '@/services/api/generated/treatmentRecordRequestsService';

export type RecordRequestProgressActionType =
  | 'status_change'
  | 'channel_submit'
  | 'invoice_upload'
  | 'records_upload';

export interface RecordRequestProgressStep {
  status: TreatmentRecordRequestStatus;
  label: string;
  shortLabel: string;
  ctaText: string;
  actionType: RecordRequestProgressActionType;
}

export const RECORD_REQUEST_PROGRESS_STEPS: RecordRequestProgressStep[] = [
  {
    status: 'pending',
    label: 'Send to Provider',
    shortLabel: 'Send',
    ctaText: 'Prepare HIPAA',
    actionType: 'status_change',
  },
  {
    status: 'request_submitted',
    label: 'Confirm Receipt',
    shortLabel: 'Confirm',
    ctaText: 'Confirm Receipt',
    actionType: 'channel_submit',
  },
  {
    status: 'request_received',
    label: 'Follow-Up on Processing',
    shortLabel: 'Follow-Up',
    ctaText: "Provider Ack'd",
    actionType: 'status_change',
  },
  {
    status: 'awaiting_invoice',
    label: 'Await Invoice',
    shortLabel: 'Invoice',
    ctaText: 'Mark Received',
    actionType: 'invoice_upload',
  },
  {
    status: 'pending_payment',
    label: 'Pay the Invoice',
    shortLabel: 'Pay',
    ctaText: 'Mark as Paid',
    actionType: 'status_change',
  },
  {
    status: 'records_pending',
    label: 'Confirm Payment Receipt',
    shortLabel: 'Payment',
    ctaText: 'Payment Confirmed',
    actionType: 'status_change',
  },
  {
    status: 'records_delivered',
    label: 'Wait for Records',
    shortLabel: 'Wait',
    ctaText: 'Mark Received',
    actionType: 'records_upload',
  },
  {
    status: 'records_ingested',
    label: 'Completed',
    shortLabel: 'Done',
    ctaText: 'Complete',
    actionType: 'status_change',
  },
];

export const getRequestProgressIndex = (
  status: TreatmentRecordRequestStatus,
): number => {
  return RECORD_REQUEST_PROGRESS_STEPS.findIndex((s) => s.status === status);
};

export const getNextRequestProgressIndex = ({
  currentStatusIndex,
  isTerminal,
}: {
  currentStatusIndex: number;
  isTerminal: boolean;
}): number => {
  const nextIndex = isTerminal ? currentStatusIndex : currentStatusIndex + 1;

  return Math.min(
    Math.max(nextIndex, 0),
    RECORD_REQUEST_PROGRESS_STEPS.length - 1,
  );
};
